import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  initialize() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "customer_sign_up",
    });
  }
}
